import { createSlice } from "@reduxjs/toolkit";

export const JEWELLER_POPUP_LOGIN_FLAG = "showJewellerInstalaxmiPopup";

const luckyDrawPopupSlice = createSlice({
  name: "luckyDrawPopup",
  initialState: {
    loading: false,
    saving: false,
    statusUpdatingId: null,
    popupData: [],
    total: 0,
    saveVersion: 0,
    error: null,
    jewellerPopup: null,
    jewellerPopupOpen: false,
    jewellerPopupLoading: false,
  },

  reducers: {
    saveInstalaxmiPopupRequest: (state) => {
      state.saving = true;
      state.error = null;
    },

    saveInstalaxmiPopupSuccess: (state) => {
      state.saving = false;
      state.saveVersion += 1;
    },

    saveInstalaxmiPopupFailure: (state, action) => {
      state.saving = false;
      state.error = action.payload;
    },

    getInstalaxmiPopupsRequest: (state) => {
      state.loading = true;
    },

    getInstalaxmiPopupsSuccess: (state, action) => {
      state.loading = false;
      state.popupData = action?.payload?.data?.data || [];
      state.total = action?.payload?.data?.total || 0;
    },

    getInstalaxmiPopupsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    updateInstalaxmiPopupStatusRequest: (state, action) => {
      state.statusUpdatingId = action.payload?.id || null;
      state.error = null;
    },

    updateInstalaxmiPopupStatusSuccess: (state) => {
      state.statusUpdatingId = null;
    },

    updateInstalaxmiPopupStatusFailure: (state, action) => {
      state.statusUpdatingId = null;
      state.error = action.payload;
    },

    getJewellerInstalaxmiPopupRequest: (state) => {
      state.jewellerPopupLoading = true;
      state.jewellerPopup = null;
      state.jewellerPopupOpen = false;
    },

    getJewellerInstalaxmiPopupSuccess: (state, action) => {
      state.jewellerPopupLoading = false;
      const popup = action.payload;
      const files = Array.isArray(popup?.files)
        ? popup.files.filter(Boolean)
        : [];
      if (popup && files.length) {
        console.log("[JewellerPopup] reducer SUCCESS — opening popup", {
          id: popup._id,
          filesCount: files.length,
        });
        state.jewellerPopup = { ...popup, files };
        state.jewellerPopupOpen = true;
      } else {
        console.log("[JewellerPopup] reducer SUCCESS but not opening", {
          reason: !popup ? "API data is null" : "files array is empty",
          popup,
        });
        state.jewellerPopup = null;
        state.jewellerPopupOpen = false;
      }
    },

    getJewellerInstalaxmiPopupFailure: (state) => {
      console.log("[JewellerPopup] reducer FAILURE — popup closed");
      state.jewellerPopupLoading = false;
      state.jewellerPopup = null;
      state.jewellerPopupOpen = false;
    },

    closeJewellerInstalaxmiPopup: (state) => {
      state.jewellerPopupOpen = false;
    },
  },
});

export const {
  saveInstalaxmiPopupRequest,
  saveInstalaxmiPopupSuccess,
  saveInstalaxmiPopupFailure,
  getInstalaxmiPopupsRequest,
  getInstalaxmiPopupsSuccess,
  getInstalaxmiPopupsFailure,
  updateInstalaxmiPopupStatusRequest,
  updateInstalaxmiPopupStatusSuccess,
  updateInstalaxmiPopupStatusFailure,
  getJewellerInstalaxmiPopupRequest,
  getJewellerInstalaxmiPopupSuccess,
  getJewellerInstalaxmiPopupFailure,
  closeJewellerInstalaxmiPopup,
} = luckyDrawPopupSlice.actions;

export default luckyDrawPopupSlice.reducer;
